import './styles.scss';
import { News } from './controller';
import * as timeago from 'timeago.js';

const locale = (number, index, totalSec) => {
  return [
    ['just now', 'right now'],
    ['%ss ago', 'in %ss'],
    ['1m ago', 'in 1m'],
    ['%sm ago', 'in %sm'],
    ['1h ago', 'in 1h'],
    ['%sh ago', 'in %sh'],
    ['1d ago', 'in 1d'],
    ['%sd ago', 'in %sd'],
    ['1w ago', 'in 1w'],
    ['%sw ago', 'in %sw'],
    ['1mo ago', 'in 1mo'],
    ['%smo ago', 'in %smo'],
    ['1yr ago', 'in 1yr'],
    ['%syr ago', 'in %syr'],
  ][index]
}
timeago.register('en_short', locale)

var NewsView = () => {
  let data
  return {
    oninit: async (vnode) => {
      data = await News.fetch()
      setTimeout(() => {
        timeago.render(
          vnode.dom.querySelectorAll('.timeago'),
          'en_short'
        )
      }, 16)
    },
    view: (vnode) => {
      return m("ons-list.news-list", [
        data && data.map(item => {
          return m("ons-list-item", [
            m("div.left",
              // m("img.list-item__thumbnail[src='https://placekitten.com/g/40/40']")
            ),
            m("div.center", [
              m("span.list-item__title",
                m.trust(item.description)
              ),
              false &&
              m("span.list-item__subtitle",
                item.source.$t
              )
            ]),
            m("div.right",
              m(".date.timeago", {
                datetime: item.pubDate
              })
            )
          ])
        })
      ])
    }
  }
}

export default NewsView
